import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/VR.css";

export default function VR() {
  const pillars = [
    {
      title: "Advisory Solutions That Deliver Impact",
      statement:
        "Strengthen governance, clarify risk, and turn safety priorities into practical action.",
      image: "/assets/image1.jpg",
      link: "/advisory",
      cta: "Explore Advisory Solutions",
    },
    {
      title: "Training Solutions That Transform Behaviour",
      statement:
        "Build workforce capability through practical, customized, and evidence-informed learning.",
      image: "/assets/Hex2.jpg",
      link: "/training",
      cta: "Explore Training Solutions",
    },
    {
      title: "AI-Driven Safety Solutions",
      statement:
        "Apply digital tools and emerging technology to strengthen prevention and decision-making.",
      image: "/assets/Hex1.jpg",
      link: "/ai-driven-safety-solutions",
      cta: "Explore Digital & AI Solutions",
    },
    {
      title: "Strategic Partnerships",
      statement:
        "Connect expertise, research, engineering, and global networks to accelerate credible innovation.",
      image: "/assets/Partnership.jpg",
      link: "/partnerships",
      cta: "Explore Partnerships",
    },
    {
      title: "Integrated OSH Systems for Quality and Performance",
      statement:
        "Integrate governance, culture, risk, measurement, and continual improvement through a connected approach.",
      image: "/assets/Hex4.jpg",
      link: "/prime360",
      cta: "Explore Integrated Systems",
    },
    {
      title: "Insights, News and Events",
      statement:
        "Stay informed through research updates, publications, workshops, forums, and collaborative activities.",
      image: "/assets/image51.jpg",
      link: "/EventsCultureShifts",
      cta: "Explore Insights, News & Events",
    },
  ];

  return (
    // HOMEPAGE CAPABILITY PILLARS
    <section
      id="capability-pillars"
      className="vr-page-container"
      aria-labelledby="capability-pillars-title"
    >
      <div className="vr-background" aria-hidden="true">
        <span className="vr-background-glow vr-glow-left"></span>
        <span className="vr-background-glow vr-glow-right"></span>
      </div>

      <div className="vr-section-inner">
        <div className="vr-section-heading">
          <p className="vr-kicker">Our Impact Model</p>

          <h2
            id="capability-pillars-title"
            className="take-action-heading"
          >
            Six Capability Pillars
          </h2>

          <p className="vr-intro">
            GESI’s six interconnected capabilities bring together strategic
            advisory, customized learning, digital innovation, integrated
            systems, strategic partnerships, and knowledge exchange. Together,
            they help organizations strengthen prevention, improve
            decision-making, and build safer, smarter, and more resilient
            workplaces.
          </p>
        </div>

        <div className="vr-card-grid">
          {pillars.map((pillar, index) => (
            <article className="vr-item" key={pillar.title}>
              <div className="vr-item-image-wrapper">
                <img
                  src={pillar.image}
                  alt=""
                  className="vr-item-image"
                  loading="lazy"
                />

                <div className="vr-item-image-overlay"></div>

                <span className="vr-item-number" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="vr-item-text">
                <div className="vr-item-copy">
                  <h3>{pillar.title}</h3>

                  <p>{pillar.statement}</p>
                </div>

                <NavLink
                  to={pillar.link}
                  className="vr-item-link"
                  aria-label={`${pillar.cta}: ${pillar.title}`}
                >
                  <span>{pillar.cta}</span>

                  <span className="vr-item-link-arrow" aria-hidden="true">
                    ↗
                  </span>
                </NavLink>
              </div>

              <span className="vr-card-bottom-line" aria-hidden="true"></span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}